import * as utils from "common/utils";
import Alert from "components/Alert";
import { HelpTooltip } from "components/Help";

export default function MilkPoolSummary({ aggregatedData }) {
    if (!aggregatedData?.milkPool?.totalMilkSolidsInTonnes) return null;

    return (
        <>
            <Alert
                type="info"
                text={
                    <>
                        <p>
                            Shows aggregated metrics for the <b>milk pool</b>, as defined by your chosen report filters. Where applicable, these metrics are calculated using a weighted average based on milk solids production. This means that farms contributing more milk solids have a greater influence on the final percentage. By weighting values this way, the results more accurately reflect the characteristics of the milk pool as a whole, rather than treating all farms equally regardless of their production volume.
                        </p>
                        <p>
                            To see which farms in the milk pool meet your desired <b>wet matter from grass-fed feed</b> and <b>grazing days</b> thresholds, use the <b>Benchmarking by farms</b> view with appropriate <b>Wet matter from grass-fed feed</b> and <b>Grazing days</b> filters.
                        </p>
                    </>
                }
            />
            <div className="HeroValue u-mt-md">
                <div className="HeroValue-item">
                    <h5>Area</h5>
                    <div className="u-flex u-flexColumn">
                        <span id="area" className="h1">
                            {utils.numeric.format(aggregatedData.milkPool?.area)} <small>ha</small>
                        </span>
                    </div>
                    <div className="u-flex u-flexColumn">
                        <span id="milk_platform_ghgha" className="h2">
                            &nbsp;
                        </span>
                    </div>
                </div>
                <div className="HeroValue-item">
                    <h5>Farms</h5>
                    <div className="u-flex u-flexColumn">
                        <span id="farmCount" className="h1">
                            {utils.numeric.format(aggregatedData.milkPool?.farmCount)} <small>farms</small>
                        </span>
                    </div>
                    <div className="u-flex u-flexColumn">
                        <span id="milk_platform_ghgha" className="h2">
                            &nbsp;
                        </span>
                    </div>
                </div>
                <div className="HeroValue-item">
                    <h5>Total milk solids</h5>
                    <div className="u-flex u-flexColumn">
                        <span id="totalMilkSolidsInTonnes" className="h1">
                            {utils.numeric.format(aggregatedData.milkPool?.totalMilkSolidsInTonnes)} <small>t MS</small>
                        </span>
                    </div>
                    <div className="u-flex u-flexColumn">
                        <span id="milk_platform_ghgha" className="h2">
                            &nbsp;
                        </span>
                    </div>
                </div>
                <div className="HeroValue-item">
                    <h5>
                        Wet matter from grass-fed feed
                        <HelpTooltip tip="The estimated average percentage of wet matter fed to the animals from feed that meets the New Zealand Grass-fed Administrative Standards, weighted by milk solids" />
                    </h5>
                    <div className="u-flex u-flexColumn">
                        <span id="averagePercentageOfDietFromGrassFedFeed" className="h1">
                            {utils.numeric.format(aggregatedData.milkPool?.averagePercentageOfDietFromGrassFedFeed, 1)} <small>%</small>
                        </span>
                    </div>
                    <div className="u-flex u-flexColumn">
                        <span id="milk_platform_ghgha" className="h2">
                            &nbsp;
                        </span>
                    </div>
                </div>
                <div className="HeroValue-item">
                    <h5>
                        Grazing days
                        <HelpTooltip tip="The estimated average number of days the animals were grazing outdoors for at least 8 hours per day, weighted by milk solids" />
                    </h5>
                    <div className="u-flex u-flexColumn">
                        <span id="averageGrazingDays" className="h1">
                            {utils.numeric.format(aggregatedData.milkPool?.averageGrazingDays)} <small>of</small>&nbsp;
                            {utils.numeric.format(aggregatedData.milkPool?.averageDaysOnFarm)} <small>days</small>
                        </span>
                    </div>
                    <div className="u-flex u-flexColumn">
                        <span id="milk_platform_ghgha" className="h2">
                            &nbsp;
                        </span>
                    </div>
                </div>
                <div className="HeroValue-item">
                    <h5>
                        Time grazing outdoors
                        <HelpTooltip tip="The estimated average percentage of time the animals were grazing outdoors, weighted by milk solids" />
                    </h5>
                    <div className="u-flex u-flexColumn">
                        <span id="averagePercentageOfTimeWithAccessToPasture" className="h1">
                            {utils.numeric.format(aggregatedData.milkPool?.averagePercentageOfTimeWithAccessToPasture, 1)} <small>%</small>
                        </span>
                    </div>
                    <div className="u-flex u-flexColumn">
                        <span id="milk_platform_ghgha" className="h2">
                            &nbsp;
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
}
